module.exports = __webpack_public_path__ + "static/img/user_placeholder_smallest.c6ce600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile-assets/user_placeholder_smallest.png
// module id = h3Zj
// module chunks = 25